import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Trashcan = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { d: "M13.281 3.333H17.5c.42 0 .79.207 1.017.524a1.1 1.1 0 0 1 .233.726c0 .69-.56 1.25-1.25 1.25h-15a1.25 1.25 0 0 1-1.25-1.302c.002-.168.043-.331.118-.479A1.25 1.25 0 0 1 2.5 3.333h4.219v-.99A1.094 1.094 0 0 1 7.812 1.25h4.375a1.094 1.094 0 0 1 1.094 1.094v.99Z" }), _jsx("path", { fillRule: "evenodd", d: "M4.367 17.875a1.09 1.09 0 0 0 1.094.875h9.133a1.094 1.094 0 0 0 1.094-.875L17.5 7.917h-15zm4.8-6.625a1.25 1.25 0 1 0-2.5 0v4.167a1.25 1.25 0 0 0 2.5 0zM12.083 10c.69 0 1.25.56 1.25 1.25v4.167a1.25 1.25 0 0 1-2.5 0V11.25c0-.69.56-1.25 1.25-1.25" })] }));
});
Trashcan.displayName = 'Trashcan';
Trashcan.__iconComponentType = 'standard';
export default Trashcan;
//# sourceMappingURL=Trashcan.js.map